import React, {useState} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import noImg from 'assets/img/pages/usr_noimg.png';
import CommonUtil from 'utils/CommonUtil';
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import UI from "../../../../components/UI";
import userStore from "common/user/store/UserStore";
import UIUtils from "../../../../utils/UIUtils";

function ContentsContainer() {
	const history = useHistory();
	const [activeIndex, setActiveIndex]=useState(0);
	const tabClickHandler=(index:number)=>{
		setActiveIndex(index);
	};

	const [demandList, setDemandList] = useState<any[]>([]);
	const [totalCnt,setTotalCnt] = useState(0);
	const [searchDivCd, setSearchDivCd] = useState('0'); // 제목/내용 선택
	const [searchText, setSearchText] = useState('');
	const [searchOpt, setSearchOpt] = useState('');
	const [stsCd, setStsCd] = useState('');


	// 페이징 설정
	const [pageNum, setPageNum] = useState(1);      // 페이지 번호
	const [pageSize, setPageSize] = useState(10);    // 화면에 출력할 목록 갯수(10개)

	const handleSelect = (e) => {
		if(e.target.name === 'searchDivCd') {
			setSearchDivCd(e.target.value);
		} else if(e.target.name === 'stsCd'){
			setStsCd(e.target.value);
		}
	};

	async function getDemandRead() {

		let param = {
			"STS_CD": stsCd,
			"SEARCH_DIV_CD" : searchDivCd,
			"SEARCH_TEXT": searchText,
			"PAGE_NUM": pageNum,
			"PAGE_SIZE": pageSize
		}


		const response:any = await CommonUtil.execute({
			url: 'usr_1904',
			data: param
		}).then((response: any) => {

			setDemandList(response.REC);
			//전체ROW개수
			setTotalCnt(response.TOTAL);

			const result = response.REC;
			console.log(result);

		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});

	}

	//인풋 엔터체크
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			getDemandRead();
		}
	}

	async function pageMove(demandNo) {
		let dataToSend = {DEMAND_NO : demandNo};

		if(userStore.authenticated){
			history.push({
				pathname: './usr_1908',
				state: { data: dataToSend }
			});
		} else {
			UIUtils.alert("로그인이 필요합니다.").then(
				history.push({
					pathname: '/main/usr_1000/usr_1300',
					search: 'url=/main/usr_1900/usr_1908',
					state: {data: dataToSend}
				})
			);
		}

	}

	React.useEffect(() => {
		getDemandRead();
	},[pageNum])

	async function demandReq() {

		if(userStore.authenticated){
			history.push({
				pathname: './usr_1907',
			});
		} else {
			UIUtils.alert("로그인이 필요합니다.").then(
				history.push({
					pathname: '/main/usr_1000/usr_1300',
					search: 'url=/main/usr_1900/usr_1907',
				})
			);
		}

	}

	// 제목 텍스트 입력 후 엔터 시 리로딩 방지
	const submitHnadler = (e) => {
		e.preventDefault();
	}

	return (
		<PageContainer session={false}>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">상생협력기금안내</Link></li>
					<li><Link to="#">수요조사</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<h1 className="tx tx-hd2">수요조사</h1>
					<div className="fww-intro">
						<ul className="tab-menu">
							<li className={"active"}><button type="button">수요조사</button></li>
							<li onClick={() => demandReq()}><button type="button">신청 내역</button></li>
						</ul>
						<div className={ 'tab-cont active'}>
							<form name="" action="" method="" onSubmit={submitHnadler}>
								<div className="tb-search-form notice">
									<div className="tb-search-items">
										<label>조회구분</label>
										<div className="sl sl-big">
											<select name="searchDivCd" id="searchDivCd" value={searchDivCd}
													onChange={handleSelect}>
												<option value="0">전체</option>
												<option value="1">제목</option>
												<option value="2">내용</option>
											</select>
										</div>
										<UIInput className={'tf tf-big ml10'} value={searchText} placeholder={"입력하세요."} valueChanged={(value) => setSearchText(value)} onKeyEnter={(e) => activeEnter(e)}/>
									</div>
									<div className="tb-search-items">
										<label>상태</label>
										<div className="sl sl-big w218">
											<select name="stsCd" id="stsCd" value={stsCd}
													onChange={handleSelect}>
												<option value="">전체</option>
												<option value="Y">모집중</option>
												<option value="N">모집완료</option>
											</select>
										</div>

									</div>
									<Button color="pri" size="big" onClick={getDemandRead}>조회</Button>
								</div>
							</form>
							<ul className="gallery-list">
								{demandList != null &&
									demandList.map((demand, index) => (
										index <= 9 &&
										<li>
											<a href="#" onClick={(e) => {
												e.preventDefault();
												pageMove(demand.DEMAND_NO);
											}} className="gallery-items">
												<div className="thumnails">
													{demand.FILE_NM != '' ?
														(
															<img
																src={'data:application/octet-stream;base64,' + demand.FILE_NM}
																alt="thumnails"/>
														) : (
															<img src={noImg} alt="thumnails"/>
														)
													}
												</div>
												<div className="subject">
													{demand.STS_CD == 'Y' ? (
														<label className="badge badge-23 blue">모집중</label>
													) : (
														<label className="badge badge-23 gray">모집완료</label>
													)}
													<span className="txt">{demand.TITLE}</span>
												</div>
												<div className="bottoms"><span className="date">{demand.REG_DATE}</span>
												</div>
											</a>
										</li>
									))
								}
							</ul>
							{demandList.length <= 0 &&
								<div className="nd">
								<p className="tx tx-cp2 fc-666">조회된 결과가 없습니다.</p>
								</div>
							}

							<UI.PaginationBar
								totalCnt={totalCnt}
								rowCnt={10}
								currentPage={pageNum}
								onChange={(current:number) => {
									setPageNum(current);
								}}
							/>

						</div>
					</div>
				</main>
			</div>			
		</PageContainer>
	);
}
export default ContentsContainer;